import { IkeModel } from '@ikegps/core-shared';
import { addStyles } from '../../../components/theme';
import { TopologicalEditorController } from '../../../page/topological.editor.page';
import { Services } from '../../../services';
import { TopologicalEditorToolController } from '../topological.editor.tool.abstract.ctrl';
import { LocationInputState } from '../../../components/input/location.input.state';

const CSS = {
	withCreatePoleTool: 'c-PoleCreateTool__attached',
};

const Style = {
	[CSS.withCreatePoleTool]: {
		cursor: 'crosshair',
	},
};

addStyles(Style);

export class CreatePoleToolController extends TopologicalEditorToolController {
	clickEventListener: google.maps.MapsEventListener;

	constructor(public ctrl: TopologicalEditorController) {
		super(ctrl);

		ctrl.classnames.push(CSS.withCreatePoleTool);
		ctrl.map.map.setOptions({ draggableCursor: 'crosshair' });
		this.bindMapClickEvent();
	}

	bindMapClickEvent() {
		this.clickEventListener = this.ctrl.map.map.addListener('click', (event) => {
			if (!this.ctrl.isCreatePoleMode) {
				return;
			}

			const { lat, lng } = event.latLng;
			const latitude = lat().toFixed(7);
			const longitude = lng().toFixed(7);

			this.createNewPole(latitude, longitude);
		});
	}

	private createNewPole(latitude: string, longitude: string) {
		// Sort by updatedAt to find most recent, fallback to createdAt
		const sortedCollections = [...this.ctrl.collectionModels].sort((a, b) => {
			const aTime = a.updatedAt ? new Date(a.updatedAt).getTime() : a.createdAt ? new Date(a.createdAt).getTime() : 0;
			const bTime = b.updatedAt ? new Date(b.updatedAt).getTime() : b.createdAt ? new Date(b.createdAt).getTime() : 0;
			return bTime - aTime; // Most recent first
		});

		const mostRecentCollection = sortedCollections[0];

		if (!mostRecentCollection) {
			return;
		}

		const form = mostRecentCollection.schema;
		const rest = Services.Department.rest;

		const newCollection = IkeModel.Collection.create(form, rest);

		newCollection.state.jobId = this.ctrl.tag.objectId;

		this.ctrl.createEditControllerForCollection(newCollection);
		const editCtrl = this.ctrl.getEditCtrlByRevision(newCollection.revision);
		if (!editCtrl) {
			return;
		}

		let inputState = editCtrl.changeState.getState(newCollection.editableLocationField.id) as LocationInputState;

		if (!inputState) {
			inputState = new LocationInputState(newCollection.editableLocationField.schema.displayName);

			inputState.onValue(() => {
				newCollection.editableLocationField.Mutator.edited(inputState.value);
			});

			editCtrl.changeState.addState(newCollection.editableLocationField.id, inputState);

			inputState.setValue(newCollection.editableLocationField.value);
		}

		inputState.latitude.setInputValue(latitude.toString());
		inputState.longitude.setInputValue(longitude.toString());

		this.ctrl.newPoleModel.push(newCollection);

		this.ctrl.setSelectedCollectionRevision(newCollection.revision);
		this.ctrl.refreshOverlay();
	}

	destroy() {
		this.topologicalEditorController.classnames = this.topologicalEditorController.classnames.filter(
			(x) => x !== CSS.withCreatePoleTool
		);

		this.topologicalEditorController.map.map.setOptions({
			draggableCursor: '',
		});

		google.maps.event.removeListener(this.clickEventListener);
	}
}
